export default "__VITE_ASSET__siEuuZHD__"